import RespondentSingleCampaignPanel from './respondentSingleCampaignPanel.container';

export default RespondentSingleCampaignPanel;